// Maps HTTP status codes to user-safe messages and typed ApiError subclasses.
// Split out of client.ts to keep that file close to the §5.5 size target.

import {
  ApiError,
  AuthError,
  ConflictError,
  type ApiErrorContext,
} from '../errors';

export function userMessageForStatus(status: number): string {
  if (status === 401 || status === 403) {
    return 'You are not signed in or do not have access. Please sign in again.';
  }
  if (status === 404) {
    return 'We could not find what you were looking for.';
  }
  if (status === 409) {
    return 'This may have changed since you loaded it. Please refresh and try again.';
  }
  if (status >= 500) {
    return 'Something went wrong on our end. Please try again.';
  }
  return 'We could not complete that. Please try again.';
}

export function errorForStatus(
  status: number,
  devMessage: string,
  context: ApiErrorContext,
): ApiError {
  const userMessage = userMessageForStatus(status);
  const opts = { userMessage, devMessage, requestId: context.requestId, context };
  if (status === 401 || status === 403) {
    return new AuthError(opts);
  }
  if (status === 409) {
    return new ConflictError(opts);
  }
  if (status >= 500) {
    return new ApiError({ ...opts, retryable: true });
  }
  return new ApiError(opts);
}
